import type { VoidFunctionComponent } from 'react';

import Tooltip from '../../../../generic/Tooltip';
import { LabeledCheckbox, icons } from '../../../../generic';
import { JIRA_BULK_CREATE_ISSUE_MAX } from '../../../../../../shared/issuesV2';
import type { UniqueTicketEditor } from '../useUniqueTicketEditor';
import PaginationControl from '../../../../generic/Pagination/PaginationControl';

type Props = {
  selectedIssuesCount: number;
  uniqueTicketEditor?: UniqueTicketEditor
};

const UniqueJiraTicketEditor: VoidFunctionComponent<Props> = ({ uniqueTicketEditor, selectedIssuesCount }) => {
  if (!uniqueTicketEditor) {
    return null;
  }
  return (
    <>
      <div className="issues-modal__body__unique-ticket-check">
        <Tooltip
          id="issues-modal-unique-ticket-check"
          tooltip={
            selectedIssuesCount > JIRA_BULK_CREATE_ISSUE_MAX
              ? `There are ${selectedIssuesCount} selected issues. Ticket splitting is disabled when ${JIRA_BULK_CREATE_ISSUE_MAX} or more issues are selected.`
              : `This option will create ${selectedIssuesCount} unique tickets: one per FOSSA issue.`
          }
        >
          <div className="issues-modal__body__unique-ticket-check-wrapper">
            <LabeledCheckbox
              label="Unique Jira ticket per FOSSA issue"
              isDisabled={selectedIssuesCount > JIRA_BULK_CREATE_ISSUE_MAX}
              isChecked={uniqueTicketEditor.isEnabled}
              onChange={(_event, checked) => uniqueTicketEditor.setIsEnabled(checked)}
            />
          </div>
        </Tooltip>
      </div>
      {uniqueTicketEditor?.isEnabled && (
        <div className="issues-modal__body__unique-ticket-nav">
          <span>
            <span className="issues-modal__body__unique-ticket-nav-results">Results Preview</span>
            <span className="issues-modal__body__unique-ticket-nav-showing">
              {' '}
              (showing {uniqueTicketEditor.currentTicket} of {uniqueTicketEditor.tickets.length} items)
            </span>
          </span>
          <span>
            <PaginationControl icon={icons.caretLeft} onClick={() => uniqueTicketEditor.prevTicket()} />
            <PaginationControl icon={icons.caretRight} onClick={() => uniqueTicketEditor.nextTicket()} />
          </span>
        </div>
      )}
    </>
  );
};

export default UniqueJiraTicketEditor;
